import { StatusObject } from '@yes.technology/react-toolkit'
import apiAsync from 'infrastructure/shared/api/api-async'

export default async function fetchStatuses(
  objectclassUuid: unknown,
  showLoading: boolean
): Promise<StatusObject[] | null> {
  const response = await apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: 'objects/_filter',
    method: 'POST',
    obj: {
      query: {
        'situation.des': {
          $gte: globalThis.activeSituationCode
        },
        'objectclass.uuid': {
          $in: [objectclassUuid]
        }
      },
      objectclass: 'UUID_OBJECTCLASS_STATUS',
      data_storage: 'published_with_fallback',
      orderby: [],
      pagination: {
        offset: 0,
        limit: 100
      }
    },
    showLoading
  })

  return response.data.objects as StatusObject[] | null
}
